import { render, staticRenderFns } from "./OtherCommonOauthMiddlePage.vue?vue&type=template&id=4543eefe&"
import script from "./OtherCommonOauthMiddlePage.vue?vue&type=script&lang=ts&"
export * from "./OtherCommonOauthMiddlePage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports